import { jsxs as r, jsx as l } from "react/jsx-runtime";
const v = (o) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m34.054 19.105-1.079 2.796a9.369 9.369 0 0 1 4.186 3.193c1.558 2.121 1.806 4.351 1.815 5.491l2.997-.023c-.012-1.502-.339-4.441-2.396-7.242a12.373 12.373 0 0 0-5.523-4.214v-.001Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M51.924 47.848H12.042v-5.514l6.279-5.023v-7.815c0-7.508 6.057-13.615 13.503-13.615s13.492 6.098 13.503 13.593l.004 7.893 6.593 5.023v5.459l3.996-1.071v-5.955l-6.594-5.024-.003-6.33a17.555 17.555 0 0 0-5.129-12.43c-2.787-2.802-6.347-4.543-10.196-5.019V6.06l-3.996 1.082v4.84c-8.796.92-15.678 8.424-15.678 17.516v6.358l-6.279 5.023v6.967a4 4 0 0 0 4 4h13.563a6.448 6.448 0 0 0 6.43 6.098 6.448 6.448 0 0 0 6.43-6.098h14.526l-1.071-3.996.001-.002Zm-19.885 6.098a2.447 2.447 0 0 1-2.419-2.103h4.838a2.447 2.447 0 0 1-2.419 2.103Z"
        }
      )
    ]
  }
);
export {
  v as Notification
};
